import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'ecp-nav-bar-white',
    templateUrl: './nav-bar-white.component.html',
    styleUrls: ['./nav-bar-white.component.css'],
    animations: [
        trigger('displayState', [
            state('none', style({
                height: 0, display: 'none', opacity: '0',
            })),
            state('block', style({
                height: '*', display: 'block', opacity: '1',
            })),
            transition('none => block', animate('100ms linear')),
            transition('block => none', animate('100ms linear'))
        ])
    ]
})
export class NavBarWhiteComponent implements OnInit {
    @Input() ecpCustomScaling: boolean; // èªå®ä¹ä¼¸ç¼©,true å¯ä»¥ç¼©æ¾ï¼false ç¦æ­¢ç¼©æ¾
    @Input() ecpStyle: object = {};
    @Input() ecpMenuList: Array<any> = [];
    @Output() ecpGoTo = new EventEmitter();
    menuStatus = 'off';
    hoverId = 0; // å½åå·²éä¸­
    selectId = 0; // å½åé¼ æ éä¸­
    thisMenuId: any = 0; // å½åéä¸­å­èå
    hisHover = 0; // åå²éä¸­èå,æ¶ç¼©æ¶è®°å½ï¼å±å¼æ¶ä½¿ç¨


    constructor(private router: Router) {
    }

    ngOnInit() {
        if (this.ecpCustomScaling == null) {
            this.ecpCustomScaling = true;
        } else if (this.ecpCustomScaling === false) {
            this.menuStatus = 'on';
        }
    }

    // èåéä¸­
    hoverMenu(id) {
        if (this.hoverId === id) {
            this.hoverId = null;
        } else {
            this.hoverId = id;
        }
    }

    // ç§»ä¸å»ç
    selectMenu(id) {
        this.selectId = id;

    }

    // æ¸é¤éä¸­
    cleanSel() {
        this.selectId = null;
    }

    // å±å¼
    on() {
        const self = this;
        if (self.menuStatus === 'off') {
            self.hoverId = self.hisHover;

            self.menuStatus = 'on';

        }
    }

    // æ¶ç¼©
    off() {
        const self = this;
        self.hisHover = self.hoverId;
        if (self.ecpCustomScaling === true) {
            this.menuStatus = 'off';
        }
    }

    showChildMenu(i) {
        if (i === this.hoverId && this.menuStatus === 'on') {
            return 'block';
        } else {
            return 'none';
        }
    }

    selectedApp(uri: string, childHoverId?: string) {
        const self = this;
        this.ecpGoTo.emit(uri);
        if (childHoverId == null) {
            self.thisMenuId = 0;
        } else {
            self.thisMenuId = childHoverId;
        }
        // console.log('click');
        // self.router.navigate([uri]);
        return false;
    }


}
